import {
  findMatchingIdsForMultipleIds,
  formatViewObjectsPhrase,
  transformTypeFacility,
} from '../../lib/utils';
import { MarketTypes } from '../../api/types';
import { useNavigate } from 'react-router-dom';
import { BuyApartmentFlowPaths } from 'routes';
import useLimitsSecondary from '../../api/hooks/use-limits-secondary';
import useBoundStore from 'store';
import Checkbox from 'components/checkbox';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import MeaningfulHeader from 'components/meaningful-header';
import styles from './styles.module.scss';
import Loader from '../../components/loader';

const ChooseNumberOfRoomsSecondary: React.FC = () => {
  const navigate = useNavigate();
  const selectedApartmentRoomTypes = useBoundStore((s) => s.selectedApartmentRoomTypes);
  const toggleSelectedApartmentRoomTypes = useBoundStore((s) => s.toggleSelectedApartmentRoomTypes);
  const { filterLimits, count, isLoading } = useLimitsSecondary(true, MarketTypes.SECONDARY);

  const buttons: ButtonProps[] = [
    {
      variant: 'gray',
      loading: isLoading,
      disabled: isLoading || count === undefined,
      label: isLoading ? 'Загрузка' : formatViewObjectsPhrase(count),
      onClick: () => navigate(BuyApartmentFlowPaths.apartmentListBuySecondary),
    },
    {
      label: 'Продолжить',
      variant: 'secondary',
      onClick: () => navigate(BuyApartmentFlowPaths.chooseSqFootageSecondary),
    },
  ];

  const transformedTypes = filterLimits?.facilityTypes?.length
    ? transformTypeFacility(filterLimits?.facilityTypes)?.map((i) => ({
        id: i.id,
        label: i.fullTitle,
      }))
    : [];

  return (
    <BaseScreen
      buttons={buttons}
      fixedContentHeight
      title='Подбор объектов вторички'
      onBackButtonClick={() => navigate(-1)}
    >
      <MeaningfulHeader header='Количество комнат вторички' motto='Доступные планировки' />
      <>
        {isLoading ? (
          <Loader />
        ) : (
          <div className={styles.checkboxes}>
            {transformedTypes.map(({ id, label }) => (
              <Checkbox
                key={id}
                label={label}
                labelPosition='left'
                className={styles.checkbox}
                checked={selectedApartmentRoomTypes.has(id)}
                onChange={() => {
                  const facilityTypeDataIds = findMatchingIdsForMultipleIds(
                    filterLimits?.facilityTypes ?? [],
                    [id],
                  );
                  toggleSelectedApartmentRoomTypes(facilityTypeDataIds[0]);
                }}
              />
            ))}
          </div>
        )}
      </>
    </BaseScreen>
  );
};

export default ChooseNumberOfRoomsSecondary;
